import React, { useState } from 'react';

function PatientManagement() {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div style={{ maxWidth: '1000px', margin: '40px auto', padding: '20px' }}>
      <h1>Patient Management</h1>
      <p>Feature coming soon: Search and manage patient records</p>
      <input 
        type="text" 
        placeholder="Search patients..." 
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ width: '100%', padding: '12px', marginTop: '20px' }}
      />
    </div>
  );
}

export default PatientManagement;
